import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { TablePage } from "~/components/Table";
import { LqsNavigation } from "~/lqs";
import { TagFilters } from "./components/TagFilters";
import { TagSearchRequestProvider, TagTable } from "./components/TagTable";

export function TagsPage() {
  return (
    <TablePage
      title="Search Tags"
      navigation={<LqsNavigation />}
      RequestProvider={TagSearchRequestProvider}
      table={
        <>
          <DataStoreBreadcrumbs />
          <TagTable />
        </>
      }
      filters={<TagFilters />}
    />
  );
}
